import React, { useEffect, useState } from "react";
import api from "../../api";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { EMPTY_DEPT } from "./adminUtils";
import { DepartmentCard } from "./DepartmentCard";
import { DepartmentFormDialog } from "./DepartmentFormDialog";
import { ConfirmDialog } from "./ConfirmDialog";

export const DepartmentsTab = ({ companyFilter = "all" }) => {
  const [list, setList] = useState([]);
  const [emps, setEmps] = useState([]);
  const [form, setForm] = useState(null);
  const [toDelete, setToDelete] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = () => {
    api.get("/departments").then((r) => setList(r.data)).catch(() => {});
    api.get("/employees").then((r) => setEmps(r.data)).catch(() => {});
  };
  useEffect(() => { load(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);

  const save = async () => {
    if (!form.name.trim()) { toast.error("Inserisci il nome del reparto"); return; }
    setSaving(true);
    try {
      const body = { name: form.name, description: form.description, manager_id: form.manager_id || null, company: form.company || "teleborsa" };
      if (form._edit) { await api.put(`/departments/${form.id}`, body); toast.success("Reparto aggiornato"); }
      else { await api.post("/departments", body); toast.success("Reparto creato"); }
      setForm(null); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Errore"); }
    finally { setSaving(false); }
  };

  const remove = async () => {
    try { await api.delete(`/departments/${toDelete.id}`); toast.success("Reparto eliminato"); setToDelete(null); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Errore"); }
  };

  const openEdit = (d) => setForm({ ...d, manager_id: d.manager_id || "", _edit: true });
  const filtered = companyFilter === "all" ? list : list.filter((d) => (d.company || "teleborsa") === companyFilter);

  return (
    <div>
      <div className="flex items-center justify-end mb-4">
        <button onClick={() => setForm({ ...EMPTY_DEPT, company: companyFilter === "all" ? "teleborsa" : companyFilter })} className="flex items-center gap-2 bg-[#16345c] hover:bg-[#0d1b2f] text-white text-[13px] font-bold px-4 py-2.5 rounded-sm transition-colors"><Plus size={16} /> Nuovo reparto</button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
        {filtered.map((d) => <DepartmentCard key={d.id} d={d} onEdit={openEdit} onDelete={setToDelete} />)}
      </div>

      <DepartmentFormDialog form={form} setForm={setForm} emps={emps} saving={saving} onSave={save} onClose={() => setForm(null)} />

      <ConfirmDialog open={!!toDelete} onCancel={() => setToDelete(null)} onConfirm={remove} title="Eliminare il reparto?">
        Stai per eliminare il reparto <b>{toDelete?.name}</b>. I dipendenti resteranno senza reparto assegnato.
      </ConfirmDialog>
    </div>
  );
};
